import React from "react"
import { SelectContext } from "./Select";



interface SelectContentProps extends React.HTMLAttributes<HTMLDivElement> { }



// Select Content Component
export const SelectContent = React.forwardRef<HTMLDivElement, SelectContentProps>(
    ({ className = "", children }, ref) => {
        const { isOpen } = React.useContext(SelectContext)

        if (!isOpen) return null;

        return (
            <div
                ref={ref}
                className={`absolute z-50 w-full mt-1 overflow-hidden rounded-md border border-gray-200 bg-white shadow-lg ${className}`}
            >
                <div className="max-h-[300px] overflow-y-auto py-1">
                    {children}
                </div>
            </div>
        )
    }
)
SelectContent.displayName = "SelectContent"